import { render, staticRenderFns } from "./FarmBornRegistration.vue?vue&type=template&id=1d075112&scoped=true&"
import script from "./FarmBornRegistration.vue?vue&type=script&lang=js&"
export * from "./FarmBornRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d075112",
  null
  
)

export default component.exports